import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nexus-network',
  templateUrl: './nexus-network.component.html',
  styleUrls: ['./nexus-network.component.css']
})
export class NexusNetworkComponent implements OnInit {
  isMobileLayout: boolean = false;

  agents = [
    {
      name: 'Danam Nagender',
      experience: 7,
      rating: 5,
      phone: '7687XXXXXX',
      email: 'danam.xxxx@gmail.com',
      verified: true,
      expert: false,
      reraRegistered: true,
      image: 'assets/img/dhanamnagender.jpg'
    },
    {
      name: 'P Vijaya Reddy',
      experience: 5,
      rating: 4,
      phone: '9787XXXXXX',
      email: 'vijaya.xxxx@gmail.com',
      verified: false,
      expert: true,
      reraRegistered: true,
      image: 'assets/img/vijayareddy.jpg'
    },
    {
      name: 'Chintala Rama Chandra',
      experience: 7,
      rating: 5,
      phone: '9587XXXXXX',
      email: 'ramachandra.xxxx@gmail.com',
      verified: true,
      expert: false,
      reraRegistered: true,
      image: 'assets/img/Chintala Rama Chandra.jpg'
    },
    {
      name: 'Midde Krishna',
      experience: 7,
      rating: 5,
      phone: '9987XXXXXX',
      email: 'krishna.xxxx@gmail.com',
      verified: false,
      expert: true,
      reraRegistered: true,
      image: 'assets/img/Midde Krishna.jpg'
    },
    {
      name: 'Akshay Raghuram Kotian',
      experience: 7,
      rating: 3,
      phone: '9187XXXXXX',
      email: 'raghuram.xxxx@gmail.com',
      verified: true,
      expert: false,
      reraRegistered: true,
      image: 'assets/img/Akshay Raghuram Kotian.jpg'
    },
    {
      name: 'Kodimela Ramesh',
      experience: 5,
      rating: 4,
      phone: '9387XXXXXX',
      email: 'ramesh.xxxx@gmail.com',
      verified: false,
      expert: true,
      reraRegistered: true,
      image: 'assets/img/Kodimela Ramesh.jpg'
    }
  ];
  constructor() { }

  ngOnInit(): void {
    this.isMobileLayout = window.innerWidth <= 1024;
    window.onresize = () => this.isMobileLayout = window.innerWidth <= 1024;
  }

}
